import {environment} from '../../environments/environment';

const prodPort = '80';
const localhostPort = '8080';

const localhostProject = 'localhost:8080/cobidb-service';
// const prodProject = 'maneat.francecentral.cloudapp.azure.com' + ':' + prodPort;
// const prodProject = 'ocm-service-be.azurewebsites.net';
const prodProject = 'cobidb-be-poc.azurewebsites.net';

const secureEndpoint = 'training';
const url = environment.production ? 'https://' + prodProject : 'http://' + localhostProject;

/* URL API */
export const apiUrl = url + '/api/';

/* URL AUTHENTICATION */
export const authUrl = url + '/oauth/token';

/* URL PROJECT */
export const globalUrlDev = url + '/' + secureEndpoint + '/';

/* URL NOT SECURED */
export const urlDev = url;

